import axios from "axios";
import { API_BASE_URL } from "../Constant";

/* -- Start of Axios Interceptors for Data Apis -- */
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

/* Normalize every failure (network error / timeout / 4xx / 5xx) into one
   consistent shape so call sites don't each guess at the axios error shape.
   Cancellations (AbortController) are passed through untouched since callers
   key off their original `name`/`code` to distinguish an abort from a real error. */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    return Promise.reject({
      status: error.response?.status ?? null,
      message:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong. Please try again.",
      isNetworkError: !error.response,
    });
  },
);

/* Api request to fetch the data */
export const dataDisplayRequest = (config) => {
  return axiosInstance.request(config);
};
